import { createSlice } from '@reduxjs/toolkit';

interface BannerState {
  isOpen: boolean;
}

const initialState: BannerState = {
  isOpen: false,
};

const slice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    closeBanner(state: BannerState) {
      state.isOpen = false;
    },
    openBanner(state: BannerState) {
      state.isOpen = true;
    },
  },
});

export const { closeBanner, openBanner } = slice.actions;
export default slice.reducer;
